/** Site-wide constants. Anything a deploy might change lives here. */

export const INK_U_URL = import.meta.env.VITE_INK_U_URL || 'https://university.scada.ink';

/** The public help center: the appliance's built-in help, published. */
export const HELP_URL = (import.meta.env.VITE_HELP_URL || 'https://docs.scada.ink').replace(/\/+$/, '');

/** A help center article, from its path (category/article) as the help site builds it. */
export const helpLink = (path = '') => `${HELP_URL}/${path.replace(/^\/+/, '')}`;

/** The companion HMI.ink site; its buy links come back here with ?package=hmi. */
export const HMI_SITE_URL = import.meta.env.VITE_HMI_SITE_URL || 'https://www.hmi.ink';

export const SALES_EMAIL = 'sales@scada.ink';
export const SUPPORT_EMAIL = 'support@scada.ink';

/** Headline figures used across the site. Keep them true to the product. */
export const STATS = {
  drivers: '25+',
  courses: 25,
  videos: '200+',
  languages: 4,
  internet: '0',
};

/** Links into the order form with its intent preselected. */
export const orderLink = (intent: 'quote' | 'order' | 'demo' = 'quote', extra?: Record<string, string>) => {
  const params = new URLSearchParams({ intent, ...extra });
  return `/order?${params.toString()}`;
};
